<template>
    <div>
        <CRow>
            <CCol md="12">
                <CCard>
                    <CCardBody>
                        <CDataTable :striped="true" :fields="fields" :items="collabList" :loading="isLoad">
                            <template #updated_at="{ item }">
                                <td>
                                    {{ item.updated_at || '-' }}
                                </td>
                            </template>
                            <template #action="{ item }">
                                <td>
                                    <CButton class="mb-2" color="primary" @click="viewItem(item)">
                                        View
                                    </CButton>
                                </td>
                            </template>
                        </CDataTable>
                    </CCardBody>
                </CCard>
            </CCol>
        </CRow>
        <CModal title="Request Detail" :centered="true" :show.sync="showModal">
            <CRow>
                <CCol sm="4" class="d-flex flex-column">
                    <h6>Name</h6>
                    <p>{{selectedRequest.name}}</p>
                </CCol>
                <CCol sm="4" class="d-flex flex-column">
                    <h6>Phone Number</h6>
                    <p>{{selectedRequest.phone}}</p>
                </CCol>
                <CCol sm="4" class="d-flex flex-column">
                    <h6>Contact Details</h6>
                    <p>{{selectedRequest.contact_details}}</p>
                </CCol>
                <CCol sm="12" class="d-flex flex-column">
                    <h6>Experience</h6>
                    <p>{{selectedRequest.experience || '-'}}</p>
                </CCol>
                <CCol sm="6" class="d-flex flex-column">
                    <h6>Created At</h6>
                    <p>{{selectedRequest.created_at}}</p>
                </CCol>
                <CCol sm="12" class="d-flex flex-column justify-content-end">
                    <h6>Process Request</h6>
                    <CSelect v-model="statusTemp" :options="['PENDING', 'ACCEPTED', 'REJECTED']"/>
                </CCol>
            </CRow>
            <template #footer>
                <div class="d-flex w-100 justify-content-between">
                    <CButton color="danger" @click="deleteRequest">
                        Delete
                    </CButton>
                    <div class="">
                        <CButton @click="showModal = false">
                            Close
                        </CButton>
                        <CButton v-if="isStatusModified" color="primary" @click="saveChanges">
                            Save
                        </CButton>
                    </div>
                </div>
            </template>
        </CModal>
        <CPagination v-if="collabList.length" :activePage.sync="page" :pages="getTotalPage"
            @update:activePage="changePage" />
    </div>
</template>
<script>
import axios from 'axios';
import { COLLAB_GET, COLLAB_UPDATE, COLLAB_DELETE } from '../../../constants/api';
import { CPagination } from '@coreui/vue';

export default {
    data() {
        return {
            accessToken: sessionStorage.getItem('access_token') || '',
            collabList: [],
            fields: ['name', 'phone', 'contact_details', 'created_at', 'status', 'updated_at', 'action'],
            page: 1,
            totalData: 0,
            limit: 10,
            showModal: false,
            selectedRequest: {},
            statusTemp: null,
            isLoad: false
        }
    },
    computed: {
        getTotalPage() {
            return Math.ceil(this.totalData / this.limit) || 1
        },
        isStatusModified() {
            return this.statusTemp !== this.selectedRequest.status
        }
    },
    beforeMount() {
        this.fetchCollabList()
    },
    methods: {
        changePage(pageNumber) {
            this.fetchCollabList((pageNumber - 1) * this.limit)
        },
        deleteRequest() {
            if (!this.selectedRequest) return
            if (!window.confirm(`This action can't be undone, proceed to delete ${this.selectedRequest.name} collab request?`)) return
            axios.delete(`${COLLAB_DELETE}/${this.selectedRequest.id}`, {
                headers: {
                    'x-access-token': this.accessToken,
                },
            })
            .then(() => {
                this.page = 1
                this.fetchCollabList()
                this.showModal = false
            }).catch(err => {
                window.alert(`Unable to delete collab request`)
                console.error(err)
            })

        },
        fetchCollabList(start = 0) {
            this.isLoad = true
            const payload = {
                start: start,
                limit: this.limit
            }
            axios.get(COLLAB_GET, {
                params: payload,
                headers: {
                    'x-access-token': this.accessToken
                }
            }).then(({data}) => {
                this.totalData = data.totalCount
                this.collabList = data.data
                this.isLoad = false
            }).catch(err => {
                this.isLoad = false
                window.alert("Unable to get collab list")
                console.error(err)
            })
        },
        saveChanges() {
            if (!this.selectedRequest) return
            const payload = {
                status: this.statusTemp
            }
            axios.put(`${COLLAB_UPDATE}/${this.selectedRequest.id}`, payload, {
                headers: {
                    'x-access-token': this.accessToken
                }
            }).then(() => {
                window.alert("Update success")
                this.showModal = false
                this.page = 1
                this.fetchCollabList()
            }).catch(err => {
                window.alert("Unable to save changes")
                console.error(err)
            })
        },
        viewItem(item) {
            this.showModal = true
            this.selectedRequest = item
            this.statusTemp = item.status
        }
    }
}
</script>
<style scoped></style>